import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import './studentPerformance.scss';
//wrapperStyle={{ fontSize: '10px', paddingTop: '10px', paddingRight: '10px' }}
// Data for grades including course names
const gradeData = [
    { grade: 'A', courses: ['AI', 'Deep Learning'] },
    { grade: 'B', courses: ['Machine Learning'] },
    { grade: 'BC', courses: ['Autonomous Systems'] },
    { grade: 'BB', courses: ['Data Mining'] },
  ];
  
  // Data for attendance (example with potentially long course names)
  const attendanceData = [
    { name: 'AI', value: 95 },
    { name: 'Machine Learning', value: 88 },
    { name: 'Autonomous Systems', value: 92 },
    { name: 'Data Mining', value: 85 },
  ];
  
  // Colors for pie charts
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
  
  // Custom tooltip to display courses for grades and attendance for attendance
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { grade, courses, name, value } = payload[0].payload;
      if (grade) {
        return (
          <div className="custom-tooltip">
            <p className="label">{`Grade: ${grade}`}</p>
            <p className="intro">Courses: {courses.join(', ')}</p>
          </div>
        );
      } else {
        return (
          <div className="custom-tooltip">
            <p className="label">{`${name}`}</p>
            <p className="intro">Attendance: {value}%</p>
          </div>
        );
      }
    }
    return null;
  };
  
  // Custom label for attendance pie chart showing values only
  const AttendanceCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * Math.PI / 180);
    const y = cy + radius * Math.sin(-midAngle * Math.PI / 180);
  
    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor="middle"
        dominantBaseline="central"
        style={{ fontSize: '10px' }}
      >
        {`${value}%`}
      </text>
    );
  };
  
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return `${text.substring(0, maxLength)}...`;
    }
    return text;
  };
  
  const StudentPerformance = () => {
    // Transform gradeData to count courses for the Pie Chart
    const transformedGradeData = gradeData.map(item => ({
      grade: item.grade,
      value: item.courses.length,
      courses: item.courses,
    }));
  
    return (
      <div className="student-performance-container">
        {/* First Div */}
        <div className="text-info">
          <p>Thesis Grade Received: A</p>
          <p>Number of Extension Requests: 2</p>
          <p>Other Requests: 1</p>
        </div>
  
        {/* Second Div */}
        <div className="chart-container">
          <h3>Grades in Each Course</h3>
          <div className="pie-chart-wrapper">
            <PieChart width={300} height={300}>
              <Pie
                data={transformedGradeData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
                nameKey="grade"
              >
                {transformedGradeData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend
                formatter={(value) => truncateText(value, 15)} 
                wrapperStyle={{ fontSize: '10px', paddingTop: '10px', paddingRight: '10px' }}// Truncate legend item if longer than 15 characters
              />
            </PieChart>
          </div>
        </div>
  
        {/* Third Div */}
        <div className="chart-container">
          <h3>Attendance in Each Course</h3>
          <div className="pie-chart-wrapper">
            <PieChart width={300} height={300}>
              <Pie
                data={attendanceData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={80}
                fill="#82ca9d"
                dataKey="value"
                nameKey="name"
                label={({ cx, cy, midAngle, innerRadius, outerRadius, value }) => (
                  <AttendanceCustomLabel
                    cx={cx}
                    cy={cy}
                    midAngle={midAngle}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    value={value}
                  />
                )}
              >
                {attendanceData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend
                formatter={(value) => truncateText(value, 15)} // Truncate legend item if longer than 15 characters
                wrapperStyle={{ fontSize: '10px', paddingTop: '10px', paddingRight: '10px' }}
              />
            </PieChart>
          </div>
        </div>
      </div>
    );
  };
  
  export default StudentPerformance;